import { render } from "./TalentManagement.vue?vue&type=template&id=bf0675ee"
import script from "./TalentManagement.vue?vue&type=script&lang=js"
export * from "./TalentManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__